export default __webpack_public_path__ + "static/media/nav-logo.6e8e0c9f.svg";